export const UserActionType = {
  GET: "get_user",
  ACCEPT: "accept_terms",
};
